module.exports = __webpack_public_path__ + "static/img/ba_b_2.17a349a1.png";